import { render } from "./EnviarInvitacionView.vue?vue&type=template&id=f3a52a94&ts=true"
import script from "./EnviarInvitacionView.vue?vue&type=script&lang=ts"
export * from "./EnviarInvitacionView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__